const getInputValues = function(context, id, attribute) {
    return context.rootState[id][attribute];
};

export default (context, payload) => {
    const moduleId = context.getters.moduleId;
    const appState = context.rootState.appState;

    const targetId = `${moduleId}_upload`;
    const errorContainer = context.rootState[`${targetId}_file-upload-error-container`];
    if (errorContainer.errors.length === 0) {
        const fileContent = getInputValues(context, `${targetId}_file-upload`, 'files');
        const fileDescription = getInputValues(context, `${targetId}_fileDescription`, 'value');
        const DocumentType = getInputValues(context, `${targetId}_document-type`, 'value');

        const DocumentTypeLabel = appState.docUploadTypes
            .find(option => option.value === DocumentType).text;

        let uploadedFiles = [...getInputValues(context, targetId, 'uploadedFiles')];
        let FileName, FileSize, FileData;
        if (fileContent[0]) {
            FileName = fileContent[0].name;
            FileSize = fileContent[0].size;
        }

        const setAttribute = payload.oneLni.storeUtils.setAttribute;
        setAttribute(context, `${targetId}_uploadSpinner`, 'visible', true);
        setAttribute(context, `${targetId}_fileUploadLoading`, 'state', 'loading');
        setAttribute(context, `${targetId}_submitFile`, 'disabled', true);

        const TIMER_SETTING = 4000;
        const MILLISECONDS = 1000;
        setTimeout(() => {
            const reader = new FileReader();
            reader.onloadend = () => {
                FileData = reader.result
                    .replace('data:', '')
                    .replace(/^.+,/, '');
                uploadedFiles.push({
                    FileName,
                    FileDescription: fileDescription,
                    FileSize,
                    FileData,
                    DocumentType,
                    DocumentTypeLabel,
                });
                setAttribute(context, targetId, 'startTimer', true);
                setTimeout(() => {
                    setAttribute(context, targetId, 'startTimer', false);
                }, TIMER_SETTING);

                context.commit(`${targetId}/initializeValidationState`, {}, {
                    root: true,
                });

                setAttribute(context, targetId, 'uploadedFiles', uploadedFiles);
                setAttribute(context, `${moduleId}_file-uploads`, 'uploadedFiles', uploadedFiles);
                context.commit('appState/SET_VALUE', {
                    key: 'documents',
                    value: context.rootState[`${moduleId}_file-uploads`].uploadedFiles,
                }, {
                    root: true,
                });

                setAttribute(context, targetId, 'files', []);
                setAttribute(context, `${targetId}_file-upload`, 'files', []);

                setAttribute(context, `${targetId}_fileDescription`, 'value', '');
                setAttribute(context, `${targetId}_document-type`, 'value', '');
                setAttribute(context, `${targetId}_submitFile`, 'disabled', false);
                setAttribute(context, `${targetId}_fileUploadLoading`, 'state', 'success');
                setAttribute(context, `${targetId}_uploadSpinner`, 'visible', false);
            };
            reader.readAsDataURL(fileContent[0]);
        }, MILLISECONDS);
    }
};